// src/SubjectSelection.js
import React from 'react';

const SubjectSelection = ({ onSubjectSelected,  selectedSubject}) => {
  const handleSubjectChange = (event) => {
    const selectedSubject = event.target.value;
    // console.log(selectedSubject)
    onSubjectSelected(selectedSubject); // Notify the parent component of the selected subject
  };

  return (
    <div className="p-4 border rounded-md shadow-md">
      <h2 className="text-lg font-semibold mb-2">Select a Subject:</h2>
      <select
        className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:border-blue-500"
        onChange={handleSubjectChange}
      >
        <option value="">-- Select a Subject --</option>
        <option value="English">English</option>
        <option value="Hindi">Hindi</option>
        <option value="Maths">Math</option>
        <option value="Science">Science</option>
        <option value="Sst">Social Science</option>
        <option value="Evs">Evs</option> 
        <option value="Grammar">English Grammar</option>
        <option value="Computer">Computer</option>
        <option value="Vyakaran">Hindi Vyakaran</option>
        {/* <option value="Gk">General Knowledge</option> */}
      </select>
      <p className="mt-2">Selected Subject: {selectedSubject}</p>
    </div>
  );
};

export default SubjectSelection;
